export default "<p>\r\n  mailing-list works!\r\n</p>\r\n"